import AnonPromo from './AnonPromo';
export default AnonPromo;
